import React, { memo, useState, useCallback } from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Checkbox,
  TextField,
  OutlinedInput,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import { styles } from './styles';

function ProgramFilters({ filters, activeFilters, setActiveFilters }) {
  const classes = styles();
  const [programName, setProgramName] = useState('');
  const [search, setSearch] = useState({});

  const handleOnSearchChange = useCallback((event, filterName) => {
    setSearch({
      [filterName]: event.target.value,
    });
  }, []);

  const onProgramNameChange = useCallback((event) => {
    setProgramName(event.target.value);
  }, []);

  const onProgramNameKeyDown = useCallback(
    (event) => {
      if (event.key === 'Enter' && programName !== '') {
        setActiveFilters((prevFilters) => ({
          ...prevFilters,
          programName:
            prevFilters['programName'] === undefined
              ? [{ name: programName }]
              : [...prevFilters['programName'], { name: programName }],
        }));

        setProgramName('');
      }
    },
    [programName],
  );

  const handleFilterOptionToggle = useCallback(
    (value, filterName) => {
      const currentIndex =
        activeFilters[filterName] === undefined
          ? -1
          : activeFilters[filterName].indexOf(value);
      if (currentIndex === -1) {
        setActiveFilters((prevFilters) => {
          return {
            ...prevFilters,
            [filterName]:
              prevFilters[filterName] === undefined
                ? [value]
                : [...prevFilters[filterName], value],
          };
        });
      } else {
        setActiveFilters((prevFilters) => ({
          ...prevFilters,
          [filterName]: [
            ...prevFilters[filterName].slice(0, currentIndex),
            ...prevFilters[filterName].slice(currentIndex + 1),
          ],
        }));
      }
    },
    [activeFilters],
  );

  return (
    <div className={classes.root}>
      <TextField
        className={classes.txtSearchProgram}
        label="Search"
        value={programName}
        onChange={onProgramNameChange}
        onKeyDown={onProgramNameKeyDown}
      />
      <label className={classes.filtersHeaderTitle}>Filters</label>
      <div className={classes.filterSections}>
        {Object.keys(filters)
          .filter((key) => filters[key].isCheckboxList && filters[key].show)
          .map((filterName) => {
            const filter = filters[filterName];
            return (
              <Accordion
                className={classes.filterSection}
                defaultExpanded
                key={filterName}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  className={classes.filterSectionHeader}
                >
                  <span>{filter.title}</span>
                </AccordionSummary>
                <AccordionDetails className={classes.filterSectionContent}>
                  {filter.isSearchable && (
                    <OutlinedInput
                      className={classes.txtSearchFilterOptions}
                      placeholder="Search"
                      value={
                        search[filterName] && search[filterName].searchText
                      }
                      onChange={(e) => handleOnSearchChange(e, filterName)}
                    />
                  )}
                  <ul className={classes.lstFilterOptions}>
                    {filter.masterList
                      .filter((fil) =>
                        search[filterName]
                          ? fil.name
                              .toLowerCase()
                              .includes(search[filterName].toLowerCase())
                          : fil,
                      )
                      .map((fil) => {
                        return (
                          <li
                            key={`${filterName}-${fil.id}`}
                            onClick={() =>
                              handleFilterOptionToggle(fil, filterName)
                            }
                          >
                            <Checkbox
                              edge="start"
                              checked={
                                activeFilters[filterName] !== undefined &&
                                activeFilters[filterName].indexOf(fil) !== -1
                              }
                              tabIndex={-1}
                              disableRipple
                            />
                            <span>{fil.name}</span>
                          </li>
                        );
                      })}
                  </ul>
                </AccordionDetails>
              </Accordion>
            );
          })}
      </div>
    </div>
  );
}

export default memo(ProgramFilters);
